import { formatMoney } from 'helpers/format';

import { Card, Stack, Text } from '@mantine/core';

type ConfirmUpdateProps = {
  formData: {
    allItems: boolean;
    allModifiers: boolean;
    requiredChange: string;
    updateBy: string;
    updateType: string;
  };
};

export default function ConfirmUpdate({ formData }: ConfirmUpdateProps) {
  const { allItems, allModifiers, requiredChange, updateBy, updateType } = formData;

  const addSubtractCopy = updateBy === 'increase' ? 'Add' : 'Subtract';
  const toFromCopy = updateBy === 'increase' ? 'to' : 'from';

  const getItemsText = () => {
    if (allItems && allModifiers) return 'items and modifiers';
    if (allItems) return 'items';
    if (allModifiers) return 'modifiers';
    return '';
  };

  const getChangeType = () => {
    if (updateType === 'cents') return formatMoney(requiredChange);
    if (updateType === 'percentage') return `${requiredChange}%`;
    return requiredChange;
  };

  return (
    <Stack>
      <Text>Are you sure you want to make the following updates?</Text>
      <Card p="sm" bg="var(--surface-secondary)">
        <Text>
          {addSubtractCopy} {getChangeType()} {toFromCopy} {getItemsText()}
        </Text>
      </Card>
    </Stack>
  );
}
